import React, { useEffect, useState } from "react";
import { EMAIL_GRAPH ,AGENT_GRAPH} from "../../constants";
import { Line, Bar } from "react-chartjs-2";

import axios from "axios";
var emailSent = [];
var emailRead = [];
var month = [];
var emailDelivered = [];
var agentLabel = [];
var userCount = [];
const d = new Date();
let months = d.getMonth();
var currentMnth =months+1;
let currentYear = d.getFullYear();



//   axios.get(EMAIL_GRAPH).then((res) => {

//     emailRead = [];
//     emailDelivered = [];
//     emailSent = [];
//     res.data.message.map((data) => {
      
//       month.push(data.MONTH_NAME);
//       emailRead.push(data.Read);
  
//       emailSent.push(data.Sent);
//       emailDelivered.push(data.Delivered);
//     });
//   }).catch (err=> {
//     alert(err.message)
// }); 





// chartExample1 and chartExample2 options
//axios.get(EMAIL_GRAPH).then(res=>{dataobj.push(19)});

let chart_1_2_3_options = {
  maintainAspectRatio: false,
  legend: {
    display: false,
  },
  tooltips: {
    backgroundColor: "#f5f5f5",
    titleFontColor: "#333",
    bodyFontColor: "#666",
    bodySpacing: 4,
    xPadding: 12,
    mode: "nearest",
    intersect: 0,
    position: "nearest",
  },
  responsive: true,
  scales: {
    yAxes: [
      {
        barPercentage: 1.6,
        gridLines: {
          drawBorder: false,
          color: "rgba(29,140,248,0.0)",
          zeroLineColor: "transparent",
        },
        ticks: {
          suggestedMin: 60,
          suggestedMax: 125,
          padding: 20,
          fontColor: "#9a9a9a",
        },
      },
    ],
    xAxes: [
      {
        barPercentage: 1.6,
        gridLines: {
          drawBorder: false,
          color: "rgba(29,140,248,0.1)",
          zeroLineColor: "transparent",
        },
        ticks: {
          padding: 20,
          fontColor: "#9a9a9a",
        },
      },
    ],
  },
};
const getEmails = () => {
  axios.get(EMAIL_GRAPH).then((res) => {
    emailRead = [];
    emailDelivered = [];
    emailSent = [];
    res.data.message.map((data) => {
      month.push(data.MONTH_NAME);
      emailRead.push(data.Read);

      emailSent.push(data.Sent);
      emailDelivered.push(data.Delivered);
    });
  });
};



export const chartExample1 = {
  emails: (canvas) => {
    getEmails();
    let ctx = canvas.getContext("2d");

    let gradientStroke = ctx.createLinearGradient(0, 230, 0, 50);

    gradientStroke.addColorStop(1, "rgba(29,140,248,0.2)");
    gradientStroke.addColorStop(0.4, "rgba(29,140,248,0.0)");
    gradientStroke.addColorStop(0, "rgba(29,140,248,0)"); //blue colors

    return {
      labels: [
        "JAN",
        "FEB",
        "MAR",
        "APR",
        "MAY",
        "JUN",
        "JUL",
        "AUG",
        "SEP",
        "OCT",
        "NOV",
        "DEC",
      ],
      datasets: [
        {
          label: "Data",
          fill: true,
          backgroundColor: gradientStroke,
          borderColor: "#1f8ef1",
          borderWidth: 2,
          borderDash: [],
          borderDashOffset: 0.0,
          pointBackgroundColor: "#1f8ef1",
          pointBorderColor: "rgba(255,255,255,0)",
          pointHoverBackgroundColor: "#1f8ef1",
          pointBorderWidth: 20,
          pointHoverRadius: 4,
          pointHoverBorderWidth: 15,
          pointRadius: 4,
         // data: emailDelivered,
         data: [23,67,8,44,55,71,99,43,88,123,85,60],
        },
        // {
        //   label: "",
        //   fill: true,
        //   backgroundColor: gradientStroke,
        //   borderColor: "pink",
        //   borderWidth: 2,
        //   borderDash: [],
        //   borderDashOffset: 0.0,
        //   pointBackgroundColor: "pink",
        //   pointBorderColor: "rgba(255,255,255,0)",
        //   pointHoverBackgroundColor: "pink",
        //   pointBorderWidth: 20,
        //   pointHoverRadius: 4,
        //   pointHoverBorderWidth: 15,
        //   pointRadius: 4,
        //   data: emailSent,
        // },
        // {
        //   label: "",
        //   fill: true,
        //   backgroundColor: gradientStroke,
        //   borderColor: "green",
        //   borderWidth: 2,
        //   borderDash: [],
        //   borderDashOffset: 0.0,
        //   pointBackgroundColor: "green",
        //   pointBorderColor: "rgba(255,255,255,0)",
        //   pointHoverBackgroundColor: "green",
        //   pointBorderWidth: 20,
        //   pointHoverRadius: 4,
        //   pointHoverBorderWidth: 15,
        //   pointRadius: 4,
        //   data: emailRead,
        // },
      ],
    };
  },

  options: chart_1_2_3_options,

};


